(() => {
    const cl = (...args) => console.log('[A11Y]', ...args);

    const removeAttribute = (nodes, attrNameToRemove) => {
        nodes.forEach(node => node.removeAttribute(attrNameToRemove));
    };

    const addAttribute = (nodes, attrName, attrValue) => {
        nodes.forEach(node => node.setAttribute(attrName, attrValue));
    };

    const replaceRootTag = (element, newTagName) => {
        if (!element || typeof newTagName !== 'string') return null;
        const newElement = document.createElement(newTagName);
        for (const attr of element.attributes) {
            newElement.setAttribute(attr.name, attr.value);
        }
        newElement.innerHTML = element.innerHTML;
        return newElement;
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////
    // Функции правки
    function fixSearchButton(root = document) {
        const buttons = root.querySelectorAll('.gf-controls-search-button');
        buttons.forEach(btn => {
            cl('Fix Search Button');
            btn.setAttribute('aria-label', 'Search');
        });
    }

    function fixPagination(root = document) {
        const paginationEl = root.querySelector('#gf_pagination_wrap');
        if (paginationEl && paginationEl.tagName.toLowerCase() !== 'div') {
            cl('Fix Pagination Element');
            const newDiv = replaceRootTag(paginationEl, 'div');
            paginationEl.parentNode.replaceChild(newDiv, paginationEl);
        }
    }

    function fixTopSellerDropdown(root = document) {
        const labelOptions = root.querySelectorAll('.sort-by-toggle');
        labelOptions.forEach(label => {
            cl('Fix Top Seller Dropdown');
            label.removeAttribute('aria-expanded');
            label.removeAttribute('role');
        });
    }

    function fixCategoryList(root = document) {
        const buttons = root.querySelectorAll('button[type="button"][role="link"]');
        cl('Fix Category List', buttons.length);
        removeAttribute(buttons, 'aria-checked');
    }

    function fixPaginationArrow(root = document) {
        const nextArrow = root.querySelectorAll('a[rel="next"]')
        cl("Fix pagination next arrow", nextArrow)
        const prevArrow = root.querySelectorAll('a[rel="prev"]')
        cl("Fix pagination prev arrow", prevArrow)
        addAttribute(nextArrow, 'aria-label', "Next page")
        addAttribute(nextArrow, 'aria-label', "Next page")

        addAttribute(prevArrow, 'style', 'color: black !important; opacity: 1 !important;')
        addAttribute(nextArrow, 'style', 'color: black !important; opacity: 1 !important;')

    }

    ////////////////////////////////////////////////////////////////////////////////////////////////
    // Наблюдатели: каждый следит за своим элементом и вешает поднаблюдение
    const observersConfig = [
        {
            id: 'gf-tree',
            fixes: [fixCategoryList]
        },
        {
            id: 'gf-grid',
            fixes: [fixPagination]
        },
        {
            id: 'gf-controls-container',
            fixes: [fixSearchButton, fixTopSellerDropdown]
        },
        {
            id: 'gf_pagination_wrap',
            fixes: [fixPaginationArrow]
        }
    ];

    cl('Runner started');

    const globalObserver = new MutationObserver(() => {
        observersConfig.forEach(({ id, fixes }) => {
            const el = document.getElementById(id);
            if (el && !el.dataset.a11yFixed) {
                cl(`✅ ${id} appeared`);
                el.dataset.a11yFixed = 'true';

                // Запускаем фиксы сразу
                fixes.forEach(fix => fix(el));

                // Подписываемся на изменения внутри этого элемента
                const localObserver = new MutationObserver(() => {
                    fixes.forEach(fix => fix(el));
                });

                localObserver.observe(el, { childList: true, subtree: true });
            }
        });
    });

    globalObserver.observe(document.body, { childList: true, subtree: true });

    cl('Global observer started');
})();
